"use client";


// src/libraries/react/client/clientCompMethods.ts
async function getPricingTableMethod() {
  const res = await this.get("/api/autumn/components/pricing_table");
  return res;
}

export {
  getPricingTableMethod
};
